module.exports = __webpack_public_path__ + "media/gallery/photo11-40f26728.webp";